module.exports = __webpack_public_path__ + "img/vip_img.5f31f90c.png";